var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AsyncConfirmationModal',_vm._g({ref:"modal",attrs:{"translation-namespace":"administration.powerBi.reports","action":"remove"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var name = ref.name;
return [_c('IxRes',{attrs:{"context":{name: name}}},[_vm._v("administration.powerBi.reports.hints.removeReport")])]}}])},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }